module.exports = __webpack_public_path__ + "static/media/kate-mara-icon.c9c6008c.jpg";